<template>
	<div class="footers">
		<div class="w1228">
			<div class="tool df hal">
				<div>
					<div class="logo" @click="$api.toPage('index')"></div>
					<div class="time">工作时间：{{time}}</div>
					<div class="phone">{{phone}}</div>
				</div>
				<div class="flex"></div>
				<div class="btn" @click="tapBtn(1)">隐私政策</div>
				<div class="btn" @click="tapBtn(2)">用户协议</div>
				<div class="btn" @click="tapBtn(3)">关于中智</div>
				<div class="code df cf hao" v-if="!$websitecheck"><img :src="code" alt="">扫一扫小程序下单</div>
			</div>
			<div class="copyright" @click="tapBtn(4)">粤ICP备2024283350号</div>
			<div class="copyright2 df wao hao">
        <span @click="tapBtn(5)">互联网药品信息服务资格证书编号：（粤）-经营性-2024-0312</span>
        <span @click="tapBtn(6)">药品生产许可证编号：粤20260380</span>
        <span @click="tapBtn(7)">营业执照</span>
        <span @click="tapBtn(8)">执业药师</span>
        <span @click="tapBtn(9)">粤公网安备44530202000146号</span>
      </div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'footers',
	props: {},
	data () {
		return {
			time: '',
			code: '',
			phone: '',
		}
	},
	mounted(){
		this.$ajax.getFooter({}).then(r=>{
			this.time = r.working_hours
			this.code = r.bottom_code
			this.phone = r.customer_service_mobile
		})
	},
	methods: {
		tapBtn(type){
			if(type==1){ // 隐私政策
				this.$api.toPage('articles',{
					id: 'privacy',
				});
			}else if(type==2){ // 用户协议
				this.$api.toPage('articles',{
					id: 'agreement',
				});
			}else if(type==3){ // 关于中智
				this.$api.toPage('articles',{
					id: 'about',
				});
			}else if(type == 4) {
        window.open("https://beian.miit.gov.cn/", "_blank");
			}else if(type == 5) {
        // 互联网药品信息服务资格证
        window.open("https://www.yz-zeus.com/static/img/yaopinxinxi.pdf", "_blank");
			}else if(type == 6) {
        // 生产许可证
        window.open("https://www.yz-zeus.com/static/img/shengchanxuke.pdf", "_blank");
			}else if(type == 7) {
        // 营业执照
        window.open("https://www.yz-zeus.com/static/img/yingyezhizhao.png", "_blank");
			}else if(type == 8) {
        // 执业药师
        window.open("https://www.yz-zeus.com/static/img/zhiyaoyishi.jpg", "_blank");
      } else if(type == 9) {
        window.open("https://beian.mps.gov.cn/#/query/webSearch?code=44530202000146", "_blank");
      }
		},
	},
}
</script>

<style lang="less" scoped>
	.footers{
		background: #000504;
		.tool{
			padding: 48px 20px 64px 20px;
		}
		.logo{
			width: 234px;
			height: 50px;
			background: url(../../assets/img/logo3.png) center center / 100% auto no-repeat;
			cursor: pointer;
		}
		.time{
			font-family: PingFang SC, PingFang SC;
			font-weight: 500;
			font-size: 13px;
			color: rgba(255,255,255,0.68);
			line-height: 15px;
			margin-top: 24px;
		}
		.phone{
			font-family: PingFang SC, PingFang SC;
			font-weight: 500;
			font-size: 13px;
			color: rgba(255,255,255,0.68);
			line-height: 15px;
			margin-top: 16px;
		}
		.btn{
			font-family: PingFang SC, PingFang SC;
			font-weight: 500;
			font-size: 18px;
			color: rgba(255,255,255,0.92);
			line-height: 21px;
			margin-right: 80px;
		}
		.code{
			font-family: PingFang SC, PingFang SC;
			font-weight: 500;
			font-size: 13px;
			color: rgba(255,255,255,0.92);
			line-height: 15px;
			img{
				background: #fff;
				border: 3px solid #fff;
				width: 104px;
				height: 104px;
				display: block;
				object-fit: cover;
				margin-bottom: 8px;
			}
		}
		.copyright{
			border-top: 1px solid rgba(255,255,255,0.16);
			margin: 0 20px;
			font-family: PingFang SC, PingFang SC;
			font-weight: 500;
			font-size: 13px;
			color: rgba(255,255,255,0.38);
			line-height: 15px;
			padding-top: 14px;
			text-align: center;
      cursor: pointer;
		}
		.copyright2{
			margin: 0 20px;
			padding: 10px 0 32px 0;
      span{
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 12px;
        color: rgba(255,255,255,0.38);
        line-height: 14px;
        margin: 0 10px;
        cursor: pointer;
        &:hover{
          text-decoration: un;
        }
      }
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/footers/footers.vue